import { useFeatureEntitlements } from '@frontegg/react';
import { MailOutlined } from '@ant-design/icons';
import { AppNavMenu } from '..';

export const useReferralNavMenus = (): AppNavMenu[] => {
  const { isEntitled: isReferralsModuleEntitled } =
    useFeatureEntitlements('referral');

  return isReferralsModuleEntitled
    ? [
        {
          path: '/referrals',
          title: 'Inbox',
          icon: <MailOutlined />,
        },
      ]
    : [];
};
